import Footer from "@/base/Footer";
import {
  insightsLayoutCss,
  insightsSideBarCss,
  insightsDataLayoutCss,
} from "./InsightsLayout.style";
import {
  InsightsLayoutProps,
  InsightsSideNavigationBarContainerProps,
  InsightsDataLayoutProps,
} from "./InsightsLayout.type";

const InsightsLayout = ({ children }: InsightsLayoutProps) => {
  return (
    <div css={insightsLayoutCss}>
      {children}
      <Footer />
    </div>
  );
};

const InsightsDataLayout = ({
  children,
  displaySidebar,
}: InsightsDataLayoutProps) => {
  return <div css={insightsDataLayoutCss({ displaySidebar })}>{children}</div>;
};

const InsightsSideBarContainer = ({
  children,
}: InsightsSideNavigationBarContainerProps) => {
  return <aside css={insightsSideBarCss}>{children}</aside>;
};

InsightsLayout.InsightsDataLayout = InsightsDataLayout;
InsightsLayout.InsightsSideBarContainer = InsightsSideBarContainer;

export default InsightsLayout;
